module.exports = __webpack_public_path__ + "images/crunch_on_mat.png";